const images = {
  webinar_logo: require('../images/webinar_logo.png'),
  avatar: require('../images/Default.png'),
  sessionBackground: require('../images/intro05.jpg')
}

export default images



// WEBPACK FOOTER //
// ./src/config/images.js